import { Check, X } from "lucide-react";
import { DISCOUNT_CODE, DISCOUNT_PERCENT } from "@/lib/constants";

const CashbackDiscountSection = () => (
  <section id="cashback-discount" className="py-10 md:py-20 bg-card/30">
    <div className="container">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="font-display text-xl font-bold text-foreground sm:text-2xl md:text-3xl">
          heilys Cashback &amp; Discount-Code im Vergleich
        </h2>
        <p className="mt-3 text-sm text-muted-foreground md:text-base">
          Du suchst nach heilys Cashback oder einem heilys Discount-Code für Rotlichttherapie-Geräte?
          Ein klassisches Cashback-Programm bietet heilys nach aktuellem Stand nicht an. Stattdessen
          gibt es den Rabattcode <strong className="text-foreground">{DISCOUNT_CODE}</strong> als
          direkte Cashback-Alternative – mit sofortiger Preisreduktion im Checkout statt
          verzögerter Auszahlung über ein Gutscheinportal.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-3xl overflow-hidden rounded-xl border border-border bg-card">
        <div className="grid grid-cols-3 border-b border-border bg-secondary/40 text-xs font-semibold uppercase tracking-wider text-muted-foreground sm:text-sm">
          <div className="p-3 sm:p-4">Merkmal</div>
          <div className="p-3 sm:p-4 text-center">Cashback-Portal</div>
          <div className="p-3 sm:p-4 text-center text-primary">Discount-Code {DISCOUNT_CODE}</div>
        </div>
        {[
          { label: "Ersparnis", a: "1–3 % typisch", b: `${DISCOUNT_PERCENT} % sofort` },
          { label: "Auszahlung", a: "Verzögert (Wochen)", b: "Sofort im Checkout" },
          { label: "Account nötig", a: "Ja", b: "Nein" },
          { label: "Tracking-Cookies", a: "Erforderlich", b: "Nicht nötig" },
          { label: "Mindestbestellwert", a: "Häufig", b: "Keiner" },
        ].map((row) => (
          <div key={row.label} className="grid grid-cols-3 border-b border-border/50 text-xs sm:text-sm last:border-b-0">
            <div className="p-3 sm:p-4 font-medium text-foreground">{row.label}</div>
            <div className="p-3 sm:p-4 text-center text-muted-foreground">
              <span className="inline-flex items-center gap-1.5">
                <X className="h-3.5 w-3.5 text-muted-foreground/60" aria-hidden="true" />
                {row.a}
              </span>
            </div>
            <div className="p-3 sm:p-4 text-center text-foreground">
              <span className="inline-flex items-center gap-1.5">
                <Check className="h-3.5 w-3.5 text-success" aria-hidden="true" />
                {row.b}
              </span>
            </div>
          </div>
        ))}
      </div>

      <p className="mx-auto mt-6 max-w-2xl text-center text-xs text-muted-foreground sm:text-sm">
        Fazit: Der heilys Discount-Code <strong className="text-foreground">{DISCOUNT_CODE}</strong> ist
        die einfachere Cashback-Alternative – kein Account, keine Wartezeit, {DISCOUNT_PERCENT} % Rabatt
        direkt auf alle Rotlichttherapie-Geräte.
      </p>
    </div>
  </section>
);

export default CashbackDiscountSection;
